
import needIcon from "../assets/images/congratulation/need.svg";
import badIcon from "../assets/images/congratulation/bad.svg";
import soIcon from "../assets/images/congratulation/so.svg";
import greatIcon from "../assets/images/congratulation/great.svg";
import loveIcon from "../assets/images/congratulation/love.svg";

export default [
  { id: 'need_to_improve', icon: needIcon, label: 'Need to improve' },
  { id: 'bad', icon: badIcon, label: 'Bad' },
  { id: 'so', icon: soIcon, label: 'So so' },
  { id: 'great', icon: greatIcon, label: 'Great' },
  { id: 'in_love', icon: loveIcon, label: 'In love' },
]